import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const TransactionApi = {
    fetchContention: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/transaction/contention?${timeRangeQS}&id=${instanceId}&sort=contentionduration+desc&limit=${process.env.REACT_APP_API_LIMIT}`),
};

export default TransactionApi;
